/** @jsxImportSource @emotion/react */
import { useEffect, useRef } from "react";
import { tituloBase } from "../../shared";
import ConfirmarPagoAnalisis from "./ConfirmarPagoAnalisis";
import EnviarResultadoDeAnalisis from "./EnviarResultadoDeAnalisis";
import ObtenerTestReport from "./ObtenerTestReport";
import ComunicarReevaluacion from "./ComunicarReevaluacion";
import ArmadoFamiliasJuguetes from "./ArmadoFamiliasJuguetes";
import { Toast } from "primereact/toast";

export default function JuguetesOperaciones() {
  const toast = useRef(null);

  // Actualiza el título de la tab
  useEffect(() => {
    document.title = "Juguetes";
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <main css={{ marginTop: "1em" }}>
        <div className="grid">
          <div className="col-12  lg:col-6">
            <ArmadoFamiliasJuguetes />
          </div>
          <div
            className="col-12  lg:col-6"
            css={{ display: "flex", flexDirection: "column", gap: "1em" }}
          >
            <ConfirmarPagoAnalisis
              mostrarMensaje={(mensaje) => {
                toast.current?.show({ severity: "success", summary: "Éxito", detail: mensaje });
              }}
            />
            <ObtenerTestReport
              mostrarMensaje={(mensaje) => {
                toast.current?.show({ severity: "success", summary: "Éxito", detail: mensaje });
              }}
            />
            <EnviarResultadoDeAnalisis
              mostrarMensaje={(mensaje) => {
                toast.current?.show({ severity: "success", summary: "Éxito", detail: mensaje });
              }}
            />
            <ComunicarReevaluacion
              mostrarMensaje={(mensaje) => {
                toast.current?.show({ severity: "success", summary: "Éxito", detail: mensaje });
              }}
            />
          </div>
        </div>
      </main>
    </>
  );
}
